import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { fetchPage } from '../lib/cms';

export default function NotFound() {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    async function loadData() {
      const data = await fetchPage('page-404');
      setPageData(data);
    }
    loadData();
  }, []);

  const metaTitle = pageData?.meta_title || 'Siden blev ikke fundet - JE Entreprenør';
  const metaDesc = pageData?.meta_description || 'Siden du leder efter, findes desværre ikke.';
  const heroTitle = pageData?.hero_title || '404 - Siden findes ikke';
  const heroSubtitle = pageData?.hero_subtitle || 'Beklager, men den side du leder efter er gravet væk eller aldrig blevet etableret.';

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
      </Helmet>

      <section className="relative min-h-[70vh] flex items-center justify-center bg-asphalt-900 text-white py-20 overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/ca189e60-8ca7-4520-a859-93fb9daa9500/hero-entreprenoer.jpg"
            alt="JE Entreprenør 404 hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-asphalt-950/80" />
        </div>

        <div className="relative z-10 mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-safety-orange/10 text-safety-orange border border-safety-orange/20 mb-6">
            <i className="fa-solid fa-triangle-exclamation text-3xl"></i>
          </div>
          
          <h1 className="font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl">
            {heroTitle}
          </h1>
          
          <p className="mt-4 text-lg text-asphalt-200">
            {heroSubtitle}
          </p>

          <div 
            className="mt-6 text-sm text-asphalt-300 max-w-md mx-auto"
            dangerouslySetInnerHTML={{ __html: pageData?.content || '' }}
          />

          <div className="mt-10">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-lg bg-safety-orange px-6 py-3.5 text-sm font-bold text-white shadow-md hover:bg-safety-orange-hover transition-all duration-200"
            >
              <i className="fa-solid fa-house mr-2"></i>
              Gå til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
